import { OrderItem } from "./order";

/**
 * OrderStatusUpdateRequest represent Order status update request
 * @author Ayan Saha
 */
export class OrderStatusUpdateRequest {
    orderId: string;
    orderItemIds: string[];
    orderItems: Array<OrderItem>;
    labId: string;
    labName : string;
}
